<div
  class="flex items-center justify-between gap-[22px] rounded-[20px] border-2 border-solid border-background-white bg-background-white/85 px-4 py-4"
>
  <div class="flex max-w-[580px] items-center gap-[22px]">
    <lib-checkbox class="flex-shrink-0" [checked]="checked()" (click)="onTreatmentChecked()"></lib-checkbox>
    <div class="flex items-center gap-3 overflow-hidden">
      <span class="typo-h4-semibold text-primary-blue">{{ treatment().dentalCode }}</span>
      <span
        #description
        class="typo-h4-semibold text-wrap text-text-primary"
        [libUiTooltip]="description.scrollWidth > description.offsetWidth ? descriptionTooltip : undefined"
        >{{ treatment().description }}</span
      >
    </div>
  </div>
  <div class="flex items-center gap-2">
    <div class="flex flex-shrink-0 items-center gap-2">
      @for (tag of treatmentTags(); track $index) {
        <button (click)="onTreatmentClicked(tag.isSurface)" [ngClass]="tagClass" [libUiTooltip]="editTooltip" tooltipPosition="top">
          {{ tag.title }}
        </button>
      } @empty {
        <button
          (click)="onTreatmentClicked()"
          [ngClass]="tagClass"
          [libUiTooltip]="isFullMouth() ? fullMouthTooltip : editTooltip"
          tooltipPosition="top"
          [class.!cursor-default]="isFullMouth()"
        >
          {{ requiredInputTranslationString() | translate }}
        </button>
        @if (showValidationError() && checked() && !isFullMouth()) {
          <svg-icon key="px-24-warning" class="text-states-red" size="sm" />
        }
      }
    </div>
  </div>
</div>
<ng-template #descriptionTooltip>
  <div class="typo-h5-book">{{ treatment().description }}</div>
</ng-template>
<ng-template #editTooltip>
  <div class="typo-h5-book">
    {{ 'charting_add_treatment_edit_label' | translate }}
  </div>
</ng-template>
<ng-template #fullMouthTooltip>
  <div class="typo-h5-book whitespace-pre-line px-3 py-1">
    {{ 'schedule_set_to_complete_full_mouth_tooltip' | translate }}
  </div>
</ng-template>
